class MProductDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.productDrawerInner = this.querySelector(".product-drawer__inner");
      this.productDrawerCloseIcon = this.querySelector(".product-drawer__close");
      this.productDrawerInnerContent = this.querySelector(".product-drawer__inner-content");
  
      this.productDrawerCloseIcon.addEventListener("click", this.close.bind(this));
      this.addEventListener("click", this.handleClick.bind(this));
    }
  
    handleClick(event) {
      if (!event.target.closest('.product-drawer__container')) {
        this.close();
      }
    }
  
    open(productHandle) {
      this.classList.add("product-drawer--active");
  
      requestAnimationFrame(() => {
        this.style.setProperty("--m-bg-opacity", "0.5");
        this.productDrawerInner.style.setProperty("--translate-x", "0");
      });
  
      document.documentElement.classList.add("prevent-scroll");
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${currentScrollPosition}px`;
      this.renderProductContent(productHandle);
    }
  
    close() {
      if (!this.classList.contains("product-drawer--active")) {
        return;
      }
  
      this.style.setProperty("--m-bg-opacity", "0");
      this.productDrawerInner.style.setProperty("--translate-x", "210%");
  
      setTimeout(() => {
        this.classList.remove("product-drawer--active");
        document.documentElement.classList.remove("prevent-scroll");
      }, 300);
  
      this.productDrawerInnerContent.innerHTML = "";

      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);

      setTimeout(() => {
        document.documentElement.classList.remove("prevent-scroll");
      }, 100);
    }
  
    async renderProductContent(handle) {
      try {
        const response = await fetch(
          `/products/${handle}?section_id=product-drawer-content&timestamp=${Date.now()}`
        );
  
        if (!response.ok) {
          const errorObject = await response.json();
          throw new Error(errorObject.description);
        }
  
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const updatedContent = html.querySelector(".product-drawer__content");
  
        if (updatedContent && this.productDrawerInnerContent) {
          this.productDrawerInnerContent.innerHTML = "";
          this.insertHTMLWithScripts(this.productDrawerInnerContent, updatedContent.outerHTML);
        }
  
        if (typeof kachingBundlesInitialize === "function") {
          kachingBundlesInitialize();
        }
      } catch (error) {
        console.error("Error updating product drawer:", error);
      }
    }
  
    insertHTMLWithScripts(target, htmlString) {
      const temp = document.createElement("div");
      temp.innerHTML = htmlString;
  
      Array.from(temp.childNodes).forEach(node => {
        if (node.tagName !== "SCRIPT") {
          target.appendChild(node.cloneNode(true));
        }
      });
  
      temp.querySelectorAll("script").forEach(script => {
        const newScript = document.createElement("script");
  
        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.textContent = script.textContent;
        }
  
        target.appendChild(newScript);
      });
    }
  }
  
  customElements.define("m-product-drawer", MProductDrawer);
